import { resolvePath } from "@utils/resolvePath";
import { styled } from "@acko-tech/building-blocks.ui.common";

export const DiscountText = styled.div`
  color: #451999;
  text-align: center;
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.1px;
  margin-top: 8px;
  margin-bottom: -4px;
`;

export const DiscountAmount = styled.div`
  color: var(--Purple-P500, #451999);
  text-align: center;

  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px;
  letter-spacing: -0.5px;
`;

export const SavingWrapper = styled.div`
  display: inline-flex;
  padding: var(--spacing-12px, 12px) var(--spacing-24px, 24px);
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 4px;
  flex-wrap: wrap;
  border-radius: 40px;
  border: 2px solid var(--Green-G200, #8ce99a);
  background: var(--Surface-White, #fff);
  margin-top: 1rem;
`;

export const SavingText = styled.div`
  color: var(--Green-G400, #0b753e);

  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 155.556% */
`;

export const SavingAmount = styled.div`
  color: var(--Green-G400, #0b753e);
  text-align: right;

  /* Heading/X Small */
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 480px;
  padding: 108px 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  background: #fff;
  gap: 1rem;
  z-index: 2;
  @media (max-width: 768px) {
    width: 90%;
    padding: 40px 20px;
  }
`;
export const DwebWrapper = styled.div`
  background-image: url(${resolvePath("/images/headerGradient.svg")});
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  width: 100vw;
  height: 160px;
  left: 0;
  right: 0;
  pointer-events: none;
  z-index: 1000;
  ${(props: { isAddonGradient: any }) =>
    props.isAddonGradient
      ? `
      background-image: url(${resolvePath("/images/addon-header-gradient.svg")});
    `
      : `background-image: url(${resolvePath("/images/headerGradient.svg")});`}
`;

export const ParentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: ${(props) => (props.isDesktop ? "0" : "-5%")};
  left: 0;
  flex-direction: column;
  background-color: ${(props) => (props.isDesktop ? "#040222cc" : "#fff")};
  z-index: 100;
  padding-bottom: ${(props) => (props.isDesktop ? "0" : "5vh")};
`;
